/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApplicationDto } from '../../models/application-dto';
import { PageInfoDto } from '../../models/page-info-dto';

export interface ApplicationClientControllerSearchMyV1$Params {

/**
 * 페이지 크기
 */
  pageSize: number;

/**
 * 정렬 기준
 */
  orderBy?: string;

/**
 * 정렬 방향
 */
  align?: 'asc' | 'desc';

/**
 * 검색어
 */
  query?: string;

/**
 * 페이지 번호
 */
  pageNo: number;

/**
 * 행사 ID
 */
  eventId?: string;

/**
 * 신청 상태 (PENDING | APPROVED | REJECTED | CANCELLED)
 */
  status?: string;
}

export function applicationClientControllerSearchMyV1(http: HttpClient, rootUrl: string, params: ApplicationClientControllerSearchMyV1$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'items': Array<ApplicationDto>;
'pageInfo': PageInfoDto;
}>> {
  const rb = new RequestBuilder(rootUrl, applicationClientControllerSearchMyV1.PATH, 'get');
  if (params) {
    rb.query('pageSize', params.pageSize, {});
    rb.query('orderBy', params.orderBy, {});
    rb.query('align', params.align, {});
    rb.query('query', params.query, {});
    rb.query('pageNo', params.pageNo, {});
    rb.query('eventId', params.eventId, {});
    rb.query('status', params.status, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{
      'items': Array<ApplicationDto>;
      'pageInfo': PageInfoDto;
      }>;
    })
  );
}

applicationClientControllerSearchMyV1.PATH = '/api/v1/applications/client/my';
